import { teamApi } from '@/api/queries/team';
import { currentTenantName, useTenantStore } from '@/auth/tenantStore';
import { LoadingSpinner } from '@/components/common/LoadingSpinner';
import { ExternalLinksEditor } from '@/components/tenant/ExternalLinksEditor';

export function ExternalLinksPage() {
  const tenantName = useTenantStore(currentTenantName);
  const { data: links, isPending, isError, error } = teamApi.useTeamExternalLinks();
  const update = teamApi.useUpdateTeamExternalLinks();

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <div>
        <h1 style={{ margin: 0, fontSize: 22, fontWeight: 600 }}>External links</h1>
        <div style={{ fontSize: 12, color: 'var(--text-3)', marginTop: 4 }}>
          {tenantName ? `Sidebar links for ${tenantName}` : 'Sidebar links for this tenant'}
        </div>
      </div>

      {isPending ? (
        <LoadingSpinner message="Loading external links..." />
      ) : isError ? (
        <div style={{ color: 'var(--text-2)' }}>
          {error instanceof Error ? error.message : "Couldn't load external links."}
        </div>
      ) : (
        <ExternalLinksEditor
          links={links}
          saving={update.isPending}
          onSave={(externalLinks) => update.mutateAsync(externalLinks)}
        />
      )}
    </div>
  );
}
